module.exports = {
	"name": "video-player",
	"version": "1.1.7",
	"description": "",
	"main": "src/index.js",
	"scripts": {
		"start": "webpack-dev-server",
		"build": "./node_modules/webpack/bin/webpack.js",
		"report": "plato -r -d report -l .jshintrc -t video-player src"
	},
	"contributors": [
		"Iván Pérez <ivanperez@vocento.com>",
		"Jose Manuel Ortega <jmortega@vocento.com>",
		"Adolfo Sanz <asanz@vocento.com>"
	],
	"license": "SEE LICENSE IN LICENSE.md",
	"devDependencies": {
		"babel-core": "^6.17.0",
		"babel-loader": "^6.2.5",
		"babel-preset-es2015": "^6.16.0",
		"chai": "^3.5.0",
		"chalk": "^1.1.3",
		"html-webpack-plugin": "^2.24.1",
		"json-loader": "^0.5.4",
		"mocha": "^3.1.0",
		"mocha-loader": "^1.0.0",
		"webpack": "^1.13.3",
		"webpack-shell-plugin": "^0.4.3"
	}
};


//////////////////
// WEBPACK FOOTER
// ./package.json
// module id = 68
// module chunks = 1